"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const BaseLabel = styled_components_1.default.label((0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'flex',
    margin: 0,
}, ({ hide, theme }) => hide
    ? {
        fontSize: '0px',
    }
    : Object.assign({ lineHeight: 'normal', alignItems: 'center' }, theme.forms.label)));
const Label = ({ label, hideLabel, htmlFor, children, className, }) => {
    return (react_1.default.createElement(BaseLabel, { htmlFor: htmlFor, className: `label ${className}`, hide: hideLabel },
        label,
        children));
};
exports.default = Label;
//# sourceMappingURL=Label.js.map